

















import { computed, defineComponent, ref } from "@vue/composition-api";
import { PaymentSystemPublic } from "@scrile/api-provider/dist/api/PaymentSystemsProvider";
import { PurchaseSubjectTypeEnum } from "@scrile/api-provider/dist/api/PurchaseTypeProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import useBeforeUnloadTab from "@/hooks/useBeforeUnloadTab";
import BaseButton from "@/components/BaseButton";
import BaseSpinner from "@/components/BaseSpinner/BaseSpinner.vue";
import ModalView from "@/components/ModalView";
import integrationModule from "./";

export default defineComponent({
  name: "AuthorizeNet",
  components: { BaseSpinner, BaseButton, ModalView },
  props: {
    show: { type: Boolean, required: true },
    processing: { type: Boolean, required: true },
    paymentSystem: { type: Object as () => PaymentSystemPublic, required: true },
    purchaseSubject: { type: Object as () => Subject<PurchaseSubjectTypeEnum> },
  },
  setup(props, { emit }) {
    const show = computed(() => props.show);
    useBeforeUnloadTab(show);

    const loading = ref(false);

    const onSubmit = async () => {
      try {
        emit("setCloseOnError", true);
        loading.value = true;
        if (!integrationModule.assign) {
          throw new Error(`${integrationModule.name} is not support assign card`);
        }
        await integrationModule.assign({ paymentSystemId: props.paymentSystem.id });
        emit("submit", { purchaseSubject: props.purchaseSubject });
      } finally {
        loading.value = false;
      }
    };

    return {
      loading,
      onSubmit,
    };
  },
});
